<template>
    <router-view ></router-view>
</template>

<script>

  export default {
    name: 'PageIndex',
    components: {
    },
    data: function(){
      return {
      }
    }, 
    created: async function(){
    },
    mounted: function(){
      console.log('PageIndex')
    },
    methods: {
    },
    watch: {

    },
    computed: {
    }     
  }
</script>
<style scoped>
h4 {
    color: #5b5b5b;
}
</style>